export default function FAQ() {
  return (
    <section className="shell faq" id="faq">
      <h2>Questions & Answers</h2>
      <details>
        <summary>What file types are supported?</summary>
        <p>Select HEIC or HEIF files. Some HEIF encodings may not be supported.</p>
      </details>
      <details>
        <summary>Is there a maximum image resolution?</summary>
        <p>The visible design limit is 12,000 px on the longest side.</p>
      </details>
      <details>
        <summary>How many files can I convert at once?</summary>
        <p>Up to 20 files can be added to one batch, processed one at a time.</p>
      </details>
      <details>
        <summary>What are the file size restrictions?</summary>
        <p>Each file is limited to 30 MB.</p>
      </details>
    </section>
  )
}
